import React, { useMemo } from "react";
import * as THREE from "three";
import ToonNPC, { NPC_PALETTE } from "@/components/scene/ToonNPC";

// A short ascending stair to a LOCKED roof door with a toon crowd climbing up —
// dramatizes the group that chose the roof while Brian tested the descent.
export default function RoofDivergence({ position = [-6.2, 0, -2.5], rotation = [0, 0.5, 0] }) {
  const stepMat = useMemo(() => new THREE.MeshStandardMaterial({ color: 0x33363c, roughness: 0.85 }), []);
  const wallMat = useMemo(() => new THREE.MeshStandardMaterial({ color: 0x2a2c31, roughness: 0.9 }), []);
  const steps = [0, 1, 2, 3, 4, 5];
  return (
    <group position={position} rotation={rotation}>
      {/* ascending steps toward -z / +y */}
      {steps.map((s) => (
        <mesh key={s} material={stepMat} position={[0, 0.15 + s * 0.28, -s * 0.5]}>
          <boxGeometry args={[2.2, 0.28, 0.6]} />
        </mesh>
      ))}
      {/* side wall */}
      <mesh material={wallMat} position={[-1.25, 1.2, -1.2]}>
        <boxGeometry args={[0.2, 3, 4]} />
      </mesh>
      {/* locked roof door at top */}
      <mesh position={[0, 2.1, -3.1]}>
        <boxGeometry args={[1.3, 2.0, 0.12]} />
        <meshStandardMaterial color={0x1c1e22} roughness={0.5} metalness={0.5} />
      </mesh>
      <mesh position={[0.45, 2.0, -3.02]}>
        <boxGeometry args={[0.08, 0.3, 0.06]} />
        <meshStandardMaterial color={0x9a9a9a} metalness={0.8} roughness={0.3} />
      </mesh>
      {/* red LOCKED sign */}
      <mesh position={[0, 3.3, -3.0]}>
        <planeGeometry args={[1.1, 0.34]} />
        <meshStandardMaterial color={0x3a0d0a} emissive={0xb93826} emissiveIntensity={1.4} />
      </mesh>
      <pointLight color={0xb93826} intensity={0.8} distance={4} position={[0, 3.3, -2.6]} />
      {/* stairwell emergency light so the toon crowd reads against the dark */}
      <pointLight color={0xbcd0e8} intensity={2.2} distance={7} position={[0.4, 2.4, 0.6]} />
      <pointLight color={0xffe9c0} intensity={1.1} distance={5} position={[-0.6, 1.0, 0.4]} />

      {/* toon crowd climbing toward the roof */}
      <ToonNPC position={[-0.4, 0.28, -0.3]} pose="climb" rotation={[0, 0, 0]} {...NPC_PALETTE[0]} speed={5} />
      <ToonNPC position={[0.4, 0.55, -0.9]} pose="climb" rotation={[0, 0.1, 0]} {...NPC_PALETTE[1]} speed={5.5} />
      <ToonNPC position={[-0.2, 0.85, -1.5]} pose="climb" rotation={[0, -0.1, 0]} {...NPC_PALETTE[3]} speed={4.8} />
      <ToonNPC position={[0.3, 1.15, -2.0]} pose="climb" rotation={[0, 0.05, 0]} {...NPC_PALETTE[4]} speed={5.2} />
    </group>
  );
}
